import { defineModule } from "direct-vuex";
import { moduleActionContext } from "@/store";
import CriterionItemRequest from "@/models/api/filters/criterions/CriterionItemRequest";
import { DataOptions } from "vuetify";
import { DefaultDataOptions } from "@/models/components/dataTables/DataTableOptions";
import { FILTER_NAMES } from "@/static/filterNames";
import { Mail } from "@/models/api/administration/mailBox/mail";
import { getBookingsToPairWith, getMailList, pairMailWithMultipleBookings } from "@/requests/mailBox";
import { BookingToPair } from "@/models/api/administration/mailBox/BookingToPair";

export interface AdministrationMailBoxBookingFilesStateInterface {
  isTableLoading: boolean;
  tableOptions: DataOptions;
  tableData: Array<Mail>;
  tableFilters: Array<CriterionItemRequest> | null;
  tableCount: number;

  mailId: number | null;
  bookingNumber: string;
  bookingsToPairWith: Array<BookingToPair>;
  selected: Array<BookingToPair>;
}

export const AdministrationMailBoxBookingFilesState: AdministrationMailBoxBookingFilesStateInterface = {
  isTableLoading: false,
  tableOptions: new DefaultDataOptions(),
  tableData: new Array<Mail>(),
  tableFilters: null,
  tableCount: -1,

  mailId: null,
  bookingNumber: "",
  bookingsToPairWith: [],
  selected: [],
};

const AdministrationMailBoxBookingFilesModule = defineModule({
  state: AdministrationMailBoxBookingFilesState as AdministrationMailBoxBookingFilesStateInterface,
  namespaced: true as const,
  getters: {},
  mutations: {
    setIsTableLoading(state, param: boolean) {
      state.isTableLoading = param;
    },
    setTableOptions(state, param: DataOptions) {
      state.tableOptions = param;
    },
    setTableData(state, param: Array<Mail>) {
      state.tableData = param;
    },
    setTableFilters(state, param: Array<CriterionItemRequest> | null) {
      state.tableFilters = param;
    },
    setTableCount(state, param: number) {
      state.tableCount = param;
    },
    setMailId(state, param: number | null) {
      state.mailId = param;
    },
    setBookingNumber(state, param: string) {
      state.bookingNumber = param;
    },
    setBookingsToPairWith(state, param: Array<BookingToPair>) {
      state.bookingsToPairWith = param;
    },
    setSelected(state, param: Array<BookingToPair>) {
      state.selected = param;
    },
  },
  actions: {
    async downloadMailList(context) {
      const { commit, state } = _moduleActionContext(context);
      commit.setIsTableLoading(true);
      const response = await getMailList({
        count: state.tableOptions.itemsPerPage,
        page: state.tableOptions.page - 1,
        criterions: state.tableFilters,
        filterName: FILTER_NAMES.MailBoxFilter,
      });
      commit.setTableData(response.items);
      commit.setTableCount(response.totalCount);
      commit.setIsTableLoading(false);
    },
    async downloadBookingsToPairWith(context) {
      const { commit, state } = _moduleActionContext(context);
      if (state.bookingNumber) {
        const response = await getBookingsToPairWith(state.bookingNumber);
        commit.setBookingsToPairWith(response);
      }
    },
    async pairMailWithMultipleBookings(context) {
      const { state, rootDispatch } = _moduleActionContext(context);
      if (state.mailId && state.selected.length) {
        const bookingIds = state.selected.map((x) => x.id);
        await pairMailWithMultipleBookings({ mailId: state.mailId, bookingIds: bookingIds });
        await rootDispatch.popup.addSavedOkSnackbar();
      }
    },
  },
});

/* eslint-disable */
// noinspection JSUnusedLocalSymbols
export default AdministrationMailBoxBookingFilesModule;
const _moduleActionContext = (context: any) =>
  moduleActionContext(context, AdministrationMailBoxBookingFilesModule);
